import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import LeadCancelled from './icon-lead-cancelled.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <LeadCancelled {...validProps} />;
}
SvgComponent.iconName = 'leadCancelled';

export const LeadCancelledIcon = svgIconWrapper(SvgComponent);
